<template>
  <div
    class="dominos-promise"
    :shimmerProp="showShimmer"
    :data="getData"
    :errorApi="isErrorInApi"
  >
    <div v-if="dataToShow.length">
      <div>
        <div class="dp-img mb16">
          <lazy-image
            alt="page image"
            :src="bgImage"
            :src-placeholder="getPlaceHolderImg"
            class=""
          />
        </div>
        <i
          class="dp-back-btn fs-16 jfi-back-v2 pa"
          @click="handleClick(true)"
        ></i>
      </div>
      <div>
        <div class="mb20">
          <div
            id="dp-groups-id"
            class="dp-groups"
            :class="[
              groups.length > 1
                ? 'flex-row ml20 mr20 justify-content-between'
                : 'dp-groups-v2',
            ]"
          >
            <div
              v-for="(group, i) in groups"
              :id="'dp_group_' + i"
              :key="group"
              style=""
              class="pb8 pt8 dp-group tc bold"
              :class="{
                'dp-group-active': getSlectedGroup(group, currentSlectedGroup),
              }"
              @click="changeGroup(group, currentSlectedGroup, i, true, true)"
            >
              {{ group }}
            </div>
          </div>
        </div>

        <div
          id="dp-srcolling-container"
          class="plr12 dp-group-content"
          :style="getStyle"
        >
          <div v-for="(group, i) in dataToShow" :key="group?.groupId">
            <div :id="'group_' + group.groupId">
              <div
                v-for="(item, index) in group?.items"
                :key="group?.groupTitle + item.itemId"
              >
                <div v-if="item?.itemIsHero" class="mb20">
                  <Observer
                    :options="{ rootMargin: '-25% 0px -25% 0px' }"
                    @intersect="individualCardVisible(group?.groupTitle)"
                  />
                  <div
                    class="dp-group-image flex-row justify-content-center mb15"
                    v-if="item?.itemImage"
                  >
                    <lazy-image
                      alt="group image"
                      :src="item?.itemImage"
                      :src-placeholder="getPlaceHolderImg"
                      style="height: 100%"
                    />
                  </div>

                  <div
                    class="pt12 pb12 plr12 dp-group-desc color-slaty fs-14 align-items-center flex-row justify-content-center gap8"
                    style=""
                    v-if="
                      item?.itemSubTitle ||
                      (item?.itemActionLabel && item?.itemAction)
                    "
                  >
                    <span
                      v-if="item?.itemSubTitle"
                      v-html="item?.itemSubTitle"
                    ></span>
                    <span
                      v-if="item?.itemActionLabel && item?.itemAction"
                      class="dp-item-action fs-10"
                      @click="
                        handleClick(
                          false,
                          item?.itemAction,
                          group.groupTitle,
                          index,
                          false,
                          item.itemActionLabel,
                          item?.itemTitle
                        )
                      "
                      >{{ item?.itemActionLabel }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <div style="" class="flex-row gap8 mb20">
                    <Observer
                      :options="{ rootMargin: '-25% 0px -25% 0px' }"
                      @intersect="individualCardVisible(group?.groupTitle)"
                    />
                    <div class="dp-item-image" v-if="item?.itemImage">
                      <lazy-image
                        alt="item image"
                        :src="item?.itemImage"
                        :src-placeholder="getPlaceHolderImg"
                        style=""
                      />
                    </div>
                    <div
                      class="align-items-start dp-item-detail flex-column justify-content-center tl"
                    >
                      <div class="fs-16 mb4 bold lh24">
                        {{ item.itemTitle }}
                      </div>
                      <div class="dp-item-subTitle fs-14 color-slaty lh18">
                        {{ item.itemSubTitle }}
                        <span
                          v-if="item?.itemActionLabel && item?.itemAction"
                          class="dp-item-action fs-10"
                          @click="
                            handleClick(
                              false,
                              item?.itemAction,
                              group.groupTitle,
                              index,
                              false,
                              item.itemActionLabel,
                              item?.itemTitle
                            )
                          "
                          >{{ item?.itemActionLabel }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex-row justify-content-center mb40 mt40">
                <lazy-image
                  alt="divider image"
                  :src="modulePropsData?.dividerImg"
                  :src-placeholder="getPlaceHolderImg"
                  class="dp-dividerImg"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="dp-cta pTB20 plr16" v-if="pageActionLabel">
          <div
            class="btn bold"
            @click="handleClick(false, pageAction, '', index, true)"
          >
            {{ pageActionLabel }}
          </div>
        </div>
      </div>
    </div>

    <div class="dp-shimmer" v-else-if="showShimmer">
      <div class="dp-shimmer-items" style="height: 160px">
        <div class="dp-animation"></div>
      </div>
      <div class="mt20 mb15">
        <div
          style="width: 70%; height: 35px"
          class="dp-shimmer-items mb20 dp-animation"
        ></div>

        <div
          style="width: 40%; height: 100px"
          class="dp-shimmer-items mb15 dp-animation"
        ></div>
        <div
          class="dp-shimmer-items dp-animation"
          style="width: 90%; height: 60px"
        ></div>
      </div>
      <div>
        <div
          style="width: 90%; height: 90px"
          class="flex-row gap10 mb15"
          v-for="(item, i) in [1, 2, 3, 4, 5]"
          :key="i"
        >
          <div class="dp-shimmer-items dp-animation" style="width: 130px"></div>
          <div class="dp-shimmer-items dp-animation"></div>
        </div>
      </div>
    </div>

    <generic-modal
      height="100vh !important"
      width="100vw"
      padding="0"
      :animationStyle="msModalDim.animationStyle"
      @close.stop="closeTncModal($event, '')"
      v-if="showTncModal"
    >
      <template v-slot:header> </template>
      <template v-slot:body>
        <iframe
          v-if="tncPgaeUrl"
          :src="tncPgaeUrl"
          frameborder="0"
          id="bpg-iframe"
        ></iframe>
      </template>
      <template v-slot:footer> </template>
    </generic-modal>

    <alert-popup
      v-if="showAlertModal"
      @closing-function="handleDismissFromAlert"
      :callClosingFun="shouldCallClosingFunc"
      :tncEventObj="tncEventObj"
    ></alert-popup>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import Utility from "../helpers/utility";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import GenericModal from "./GenericModal.vue";
import { defineAsyncComponent } from "vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import PageNames from "../config/pageNames";
import {
  staticImgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import { Carousel, Slide } from "vue3-carousel";
import setEvents, { loadAmplitudeUnsentEvents } from "../helpers/events";
import Observer from "../assets/Observer.vue";

export default {
  name: "DominosPromise",
  props: ["moduleProps"],
  components: {
    Observer,
    GenericModal,
    Carousel,
    AlertPopup: defineAsyncComponent(() => import("./AlertPopup.vue")),
  },
  data() {
    return {
      modulePropsData: {},
      groups: [],
      currentSlectedGroup: null,
      bgImage: "",
      flagForOptimisation: false,
      dataToShow: [],
      queryObj: {},
      showTncModal: false,
      msModalDim: {
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout hide-vertical-scrollbar",
      },
      tncPgaeUrl: "",
      assetName: false,
      pageTitle: "",
      pageAction: null,
      pageActionLabel: "",
      shouldCallClosingFunc: false,
      eventFlag: false,
      tncEventObj: {
        sectionName: "BPG screen",
      },
      tabViaObserver: null,
      isClickedViaHeaderActive: false,
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
    const placeHolderImg_sq = this.modulePropsData?.placeHolder_sq;
    this.$store.commit(keyMapsMutation.UPDATE_PLACE_HOLDER_IMAGE, {
      square: placeHolderImg_sq,
    });

    this.hidePageLoader();
    document.body.classList.add("body-stop-scroll-mobile");
    this.queryObj = Utility.getQueryFromUrlWithSpace(window.location.href);
    this.assetName = this.queryObj["assetName"];

    if (this.queryObj.selGrp) {
      this.currentSlectedGroup = this.queryObj.selGrp;
    }
    this.fetchDataFromAPI();
    loadAmplitudeUnsentEvents();
  },
  methods: {
    handleTncModalClick(url = "") {
      if (url) {
        document.body.classList.add("body-stop-scroll-mobile");
        this.tncPgaeUrl = url;
        this.showTncModal = true;
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true);
      }
    },
    closeTncModal(e, source) {
      e.stopPropagation();
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showTncModal = false;
      this.tncPgaeUrl = "";
    },
    scrollingFunc(id) {
      const componentRef = document.getElementById("dp-groups-id");
      const targetEle = document.getElementById("dp_group_" + id);
      if (targetEle) {
        const futureScrollLeft = targetEle.offsetLeft;
        componentRef.scrollLeft = futureScrollLeft - 100;
      }
    },
    hidePageLoader() {
      document.getElementById("pageLoader").style.display = "none";
    },
    fetchDataFromAPI() {
      const apiPayload = {
        site: window?._siteProps_?.siteContext
          ? (window?._siteProps_?.siteContext).toLowerCase()
          : "jflcms",
        platform: "pwa",
        page: this.queryObj["page"],
        orderType: this.queryObj["orderType"] || "",
        userFrequency: this.queryObj["freq"] || "",
        storeId: this.queryObj["storeId"] || "",
        groupFilter: this.queryObj["groups"] || "",
      };

      this.$store.dispatch(keyMapsAction.GET_DOMINOS_PROMISE_DATA, apiPayload);
    },
    changeGroup(
      group,
      currentSlectedGroup = false,
      index,
      isSmooth = true,
      isClickedViaHeader = false
    ) {
      if (isClickedViaHeader) {
        this.isClickedViaHeaderActive = true;
        setTimeout(() => {
          this.isClickedViaHeaderActive = false;
        }, 1000);
      }
      const selectedGroupData = this.dataToShow.find((groupObj) => {
        return (
          groupObj.groupTitle.toLowerCase().trim() == group.toLowerCase().trim()
        );
      });
      this.currentSlectedGroup = group;
      const targetDiv = document.getElementById(
        "group_" + selectedGroupData?.groupId
      );
      const parentDiv = document.getElementById("dp-srcolling-container");

      let idV2;
      if (index == undefined) {
        idV2 = this.groups.indexOf(selectedGroupData.groupTitle);
      }

      const scrollToId = index != undefined ? index : idV2;
      this.scrollingFunc(scrollToId);
      if (targetDiv) {
        parentDiv.scrollTo({
          top: targetDiv.offsetTop - parentDiv?.offsetTop - 2,
          behavior: isSmooth ? "smooth" : "auto",
        });
      }

      if (this.eventFlag) {
        const eventObj = {
          sectionName: "navigation bar",
          category: group?.toLowerCase(),
          screenName: "BPG screen",
        };

        this.eventFunction(true, eventObj);
      } else {
        this.eventFlag = true;
      }
    },

    getSlectedGroup(group, selectedGroup = "") {
      if (!this.isClickedViaHeaderActive && this.tabViaObserver) {
        return (
          this.tabViaObserver.toLowerCase().trim() == group.toLowerCase().trim()
        );
      } else {
        return (
          group.toLowerCase().trim() == selectedGroup?.toLowerCase().trim()
        );
      }
    },
    processMyDataSorting(groups = []) {
      const finalData = groups
        .map((group) => {
          const {
            groupTitle = "",
            groupPosition = "",
            groupDesc = "",
            items = [],
            groupId = "",
            groupLabel = "",
          } = group;
          const updatedItems = items.sort(
            (a, b) => a?.itemPosition - b?.itemPosition
          );

          return {
            groupTitle,
            groupPosition,
            groupDesc,
            groupId,
            items: updatedItems,
            groupLabel,
          };
        })
        .sort((a, b) => a.groupPosition - b.groupPosition);

      return finalData;
    },
    prioritizeBySelectedGrpId(id) {
      if (id === undefined || id === null || id == "") {
        return;
      }
      const arr = this.dataToShow;
      const index = arr.findIndex((item) => item.groupId === id);

      if (index === -1) {
        return arr;
      }

      const [matchedItem] = arr.splice(index, 1);
      return [matchedItem, ...arr];
    },
    redirectPage(actionObj, goBack, pageClick, extraEventObjForLater = {}) {
      const { action = "", href = "" } =
        Utility.tryJsonParse(actionObj, [{}])[0] || "";

      let updatedHref = href;
      if (!action && !goBack) {
        this.shouldCallClosingFunc = true;
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true);
        return;
      }
      const previousLinkRewrite = (
        linkRewrite = LocalStorageFunc.getSessionStorageKey(
          "previousLinkRewrite"
        )
      ) => {
        if (Object.keys(linkRewrite).length <= 0) {
          linkRewrite = PageNames.NEXTGEN_LINKREWRITE_HOME;
        }
        return `/${linkRewrite}/`;
      };
      const url =
        projectBasePathWithFolder +
        previousLinkRewrite() +
        LocalStorageFunc.storeId();

      if (
        action &&
        action?.toLowerCase() === "bpgbenefits" &&
        this.assetName &&
        href
      ) {
        updatedHref = Utility.addUpdateParam(href, "assetName", this.assetName);
      }

      const actionData = {
        links: [
          {
            title: this.pageTitle,
            href: updatedHref,
            action: goBack ? "pageClose" : action,
            closeScreen: "true",
          },
        ],
      };

      let assetPrefix;
      if (
        action.toLowerCase() !== "redirect" &&
        this.assetName?.toLowerCase() === "ios"
      ) {
        assetPrefix = window.webkit.messageHandlers;
        const methodPrefix = assetPrefix["gamifyActions"];
        return methodPrefix["postMessage"](actionData);
      } else if (
        action.toLowerCase() !== "redirect" &&
        this.assetName?.toLowerCase() === "android"
      ) {
        assetPrefix = window.Android;
        return window.Android["gamifyActions"](JSON.stringify(actionData));
      } else {
        this.scrollOrRedirectCategory(
          action,
          href,
          url,
          pageClick,
          extraEventObjForLater
        );
      }
    },
    scrollOrRedirectCategory(
      action = "",
      href = "",
      defaultUrl = "",
      pageClick,
      scrollOrRedirectCategory = {}
    ) {
      if (action.toLowerCase() === "redirect") {
        this.handleTncModalClick(href);
        setTimeout(() => {
          const eventObj = {
            screenName: "BPG claim screen",
            Page_Name: "BPG Screen",
          };
          const { sectionName = "" } = scrollOrRedirectCategory;
          if (sectionName) {
            eventObj.sectionName = sectionName;
          }
          this.eventFunction(false, eventObj, "", false);
        }, 300);
      } else {
        if (pageClick) {
          this.shouldCallClosingFunc = true;
        } else {
          this.shouldCallClosingFunc = false;
        }
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true);
      }
    },
    eventFunction(
      isClicked = false,
      eObj = {},
      userAction = "",
      screenFlag = true
    ) {
      const eventType = isClicked ? "click" : "screenView";
      const preEventObj = {
        ...eObj,
        screenName: screenFlag ? "BPG screen" : eObj.screenName,
      };
      const eventObj = Utility.amplitudeEventObj(
        userAction ? userAction : eventType,
        eObj?.sectionName ? eObj.sectionName?.toLowerCase() : "",
        "1",
        preEventObj
      );

      if (!isClicked && !screenFlag) {
        eventObj["Page_Name"] = "BPG Screen"; //claim page/modal edgecase
      }
      this.tncEventObj = {
        ...eventObj,
        eventType: eventType,
      };
      setEvents("amplitude", eventType, eventObj);
    },
    handleClick(
      goBack = false,
      actionObj,
      group = "",
      index = 0,
      pageClick = false,
      actionCta = "",
      itemTitle = "",
      eventFlagFromAlertPopUp = true
    ) {
      const category = goBack
        ? "back click"
        : pageClick
        ? this.pageActionLabel?.toLowerCase()
        : itemTitle?.toLowerCase();

      const eventObj = {
        sectionName: group ? group : this.currentSlectedGroup,
        category: category ? category : this.currentSlectedGroup,
        screenName: "BPG screen",
      };

      if (eventFlagFromAlertPopUp) {
        this.eventFunction(true, eventObj, actionCta?.toLowerCase());
      }

      this.redirectPage(actionObj, goBack, pageClick, eventObj);
    },
    handleDismissFromAlert(back = true, eventCall = false) {
      this.handleClick(back, null, "", 0, false, "", "", eventCall);
    },
    individualCardVisible(item) {
      this.tabViaObserver = item;
    },
  },
  computed: {
    getStyle() {
      const ele = document.getElementsByClassName("pg-wrapper") || [];
      if (ele && Object.keys(ele).length) {
        ele[0].style.paddingBottom = "0";
      }
      const style = {
        maxHeight: "calc(100vh - 270px)",
        overflowY: "scroll",
      };
      return style;
    },
    getData() {
      const {
        groups = [],
        pageCoverImage = "",
        pageTitle = "",
        pageActionLabel = "",
        pageActionValue = "[{}]",
      } = this.$store.state.DynamicWidget.dominosPromiseData || {};
      this.bgImage = pageCoverImage;
      this.pageTitle = pageTitle;
      this.pageAction = pageActionValue;
      this.pageActionLabel = pageActionLabel;

      if (groups.length) {
        const arr = groups.filter((i) => {
          if (i?.groupTitle) {
            return i;
          }
          return false;
        });
        const processedData = this.processMyDataSorting(arr);
        this.groups = processedData.map((item) => {
          return item.groupTitle;
        });
        this.dataToShow = processedData;

        setTimeout(() => {
          let currentSlectedGroupTitle = "";
          const isUrlGrpPresent = processedData.findIndex((i) => {
            const val =
              i?.groupLabel?.toLowerCase() ==
              this.currentSlectedGroup?.toLowerCase();
            if (val) {
              currentSlectedGroupTitle = i?.groupTitle;
            }
            return val;
          });
          if (currentSlectedGroupTitle && isUrlGrpPresent != -1) {
            this.changeGroup(currentSlectedGroupTitle, true, undefined, false);
            const eventObj = {
              sectionName: currentSlectedGroupTitle,
            };
            this.eventFunction(false, eventObj);
          } else {
            if (this.groups.length) {
              this.changeGroup(this.groups[0]);
              const eventObj = { sectionName: this.groups[0] };
              this.eventFunction(false, eventObj);
            }
          }
        }, 0);
        return true;
      }
      return false;
    },
    showAlertModal() {
      return this.$store.state.DynamicWidget.showAlertModal;
    },
    showShimmer() {
      const shimmer = this.$store.state.DynamicWidget.showDominosPromiseShimmer;
      if (!shimmer) {
        document.body.classList.remove("body-stop-scroll-mobile");
      }
      return shimmer;
    },
    isErrorInApi() {
      const error = this.$store.state.DynamicWidget.showDominosPromiseError;
      if (error) {
        this.shouldCallClosingFunc = true;
      }
      return error;
    },
    getPlaceHolderImg() {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      return img || fallBack;
    },
  },
};
</script>
